/**
 * 개발 도구 — PC·서버 자산 (/adm/dev/pc-inventory) — 수집 스크립트가 보고한 장비 목록·메모·스크립트 편집
 * ($j.Pages.Admin.PcInventory / body data-page-name="PcInventory")
 *
 * 디스크 막대 폭(사용률)만 --pct 로 넘기고 모양은 sass 가 그린다.
 */
export default class PcInventory {
    initialize() { initialize(); }
}

let dtInventory = null;

function initialize() {
    initTable();

    // 버튼 — 표 행(수정·삭제), 검색줄(스크립트 편집), 모달(취소·저장). 모두 다시 그려지므로 위임
    $(document).on('click', '[data-pci]', function () {
        const a = this.dataset.pci, n = Number(this.dataset.n);
        if (a === 'detail') openDetail(n);
        else if (a === 'delete') deleteRow(n);
        else if (a === 'script') openScriptEditor();
        else if (a === 'saveDetail') saveDetail(n);
        else if (a === 'saveScript') saveScript();
        else if (a === 'close') $j.Ui.JBModal.close(this.dataset.modal);
    });
}

function initTable() {
    dtInventory = new DataTable('#table-inventory', {
        autoWidth: false,
        columns: [
            { data: 'hostname', title: '호스트명', width: '120px' },
            { data: 'device_type', title: '구분', width: '60px', className: 'text-center',
                render: (data) => data === 'server' ? '<span class="badge-server">서버</span>' : '<span class="badge-pc">PC</span>'
            },
            { data: 'owner', title: '소유자', width: '80px',
                render: (data, type, row) => type !== 'display' ? data : `<span class="memo-inline" data-num="${row.num}" data-field="owner" contenteditable="false">${data || ''}</span>`
            },
            { data: 'purpose', title: '용도', width: '120px',
                render: (data, type, row) => type !== 'display' ? data : `<span class="memo-inline" data-num="${row.num}" data-field="purpose" contenteditable="false">${data || ''}</span>`
            },
            { data: 'cpu_model', title: 'CPU', width: '160px',
                render: (data, type, row) => {
                    if (type !== 'display') return data;
                    const short = data ? (data.length > 30 ? data.substring(0, 30) + '…' : data) : '';
                    return `<span title="${data || ''}">${short}</span>` + (row.cpu_cores ? ` <small class="text-muted">(${row.cpu_cores}코어)</small>` : '');
                }
            },
            { data: 'ram_total_gb', title: 'RAM', width: '60px', className: 'text-right',
                render: (data) => data ? data + ' GB' : ''
            },
            { data: 'disk_info', title: '디스크', width: '180px',
                render: (data) => {
                    if (!data || !data.length) return '';
                    return data.map(d => {
                        const pct = d.percent || 0;
                        const cls = pct >= 90 ? 'disk-danger' : (pct >= 75 ? 'disk-warn' : 'disk-ok');
                        return `<div class="pci-disk"><small>${d.mount} ${d.total_gb}GB (잔여 ${d.free_gb}GB)</small><div class="disk-bar"><div class="disk-bar-fill ${cls}" style="--pct:${pct}%"></div></div></div>`;
                    }).join('');
                }
            },
            { data: 'os_name', title: 'OS', width: '100px',
                render: (data, type, row) => (data || '') + (row.os_version ? ' ' + row.os_version : '')
            },
            { data: 'ip', title: 'IP', width: '110px' },
            { data: 'last_report', title: '최근 보고', width: '130px',
                render: (data) => {
                    if (!data) return '';
                    const diff = (Date.now() - new Date(data).getTime()) / 86400000;
                    const cls = diff > 7 ? 'stale-report' : '';
                    return `<span class="${cls}">${data}</span>`;
                }
            },
            { data: null, title: '', width: '60px', orderable: false, className: 'text-center',
                render: (data, type, row) => `<button class="btn btn-default btn-xs" data-pci="detail" data-n="${row.num}"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" data-pci="delete" data-n="${row.num}"><i class="fa fa-trash"></i></button>`
            },
        ],
        ajax: { url: '/adm/ajax/dev/pc-inventory/list', type: 'post' },
        language: {
            emptyTable: '등록된 장비가 없습니다.',
            search: '검색:',
            info: '총 _TOTAL_건',
            infoEmpty: '',
        },
        processing: true,
        serverSide: false,
        ordering: true,
        order: [[9, 'desc']],
        pageLength: 50,
        lengthChange: false,
    });

    // 검색 영역에 스크립트 버튼
    const $filter = $(dtInventory.table().container()).find('.dt-search, .dataTables_filter').first();
    $filter.addClass('pci-filter');
    $filter.append('<button class="btn btn-default btn-sm pci-nowrap" data-pci="script"><i class="fa fa-code"></i> 스크립트 편집</button>');
    $filter.append('<a href="/adm/dev/pc-inventory/script" class="btn btn-default btn-sm pci-nowrap"><i class="fa fa-download"></i> 다운로드</a>');

    // 인라인 편집
    $('#table-inventory').on('click', '.memo-inline', function () {
        const $el = $(this);
        if ($el.attr('contenteditable') === 'true') return;
        const orig = $el.text();
        $el.attr('contenteditable', 'true').focus();
        $el.one('keypress', function (e) { if (e.which === 13) { e.preventDefault(); $el.blur(); } });
        $el.one('blur', function () {
            $el.attr('contenteditable', 'false');
            const val = $el.text().trim();
            if (val !== orig) {
                $.post('/adm/ajax/dev/pc-inventory/edit', { num: $el.data('num'), [$el.data('field')]: val });
            }
        });
    });
}

function openDetail(num) {
    const row = dtInventory.rows().data().toArray().find(r => r.num == num);
    if (!row) return;

    let diskHtml = '';
    if (row.disk_info?.length) {
        diskHtml = row.disk_info.map(d => {
            const pct = d.percent || 0;
            const cls = pct >= 90 ? 'disk-danger' : (pct >= 75 ? 'disk-warn' : 'disk-ok');
            return `<div class="pci-det-disk">${d.mount} — ${d.total_gb}GB (사용 ${d.used_gb}GB / 잔여 ${d.free_gb}GB, ${pct}%)<div class="disk-bar pci-bar-lg"><div class="disk-bar-fill ${cls}" style="--pct:${pct}%"></div></div></div>`;
        }).join('');
    }

    const html = `
        <div class="form-group"><label>이름</label><input type="text" id="detLabel" class="form-control" value="${row.label || ''}"></div>
        <div class="form-group"><label>용도</label><input type="text" id="detPurpose" class="form-control" value="${row.purpose || ''}"></div>
        <div class="form-group"><label>소유자</label><input type="text" id="detOwner" class="form-control" value="${row.owner || ''}"></div>
        <div class="form-group">
            <label>구분</label>
            <select id="detType" class="form-control">
                <option value="pc" ${row.device_type === 'pc' ? 'selected' : ''}>PC</option>
                <option value="server" ${row.device_type === 'server' ? 'selected' : ''}>서버</option>
            </select>
        </div>
        <hr>
        <table class="table table-condensed pci-det-table">
            <tr><td class="pci-det-th"><b>호스트</b></td><td>${row.hostname}</td></tr>
            <tr><td><b>IP</b></td><td>${row.ip}</td></tr>
            <tr><td><b>MAC</b></td><td>${row.mac_address}</td></tr>
            <tr><td><b>OS</b></td><td>${row.os_name} ${row.os_version}</td></tr>
            <tr><td><b>CPU</b></td><td>${row.cpu_model} (${row.cpu_cores}코어)</td></tr>
            <tr><td><b>RAM</b></td><td>${row.ram_total_gb} GB</td></tr>
            <tr><td><b>GPU</b></td><td>${row.gpu_model || '-'}</td></tr>
        </table>
        ${diskHtml ? '<div class="pci-det-disks"><b>디스크</b>' + diskHtml + '</div>' : ''}
        <div class="pci-acts">
            <button class="btn btn-default btn-sm" data-pci="close" data-modal="detailModal">취소</button>
            <button class="btn btn-primary btn-sm" data-pci="saveDetail" data-n="${row.num}">저장</button>
        </div>
    `;
    $j.Ui.JBModal.html('detailModal', html, row.hostname);
}

function saveDetail(num) {
    $.post('/adm/ajax/dev/pc-inventory/edit', {
        num,
        label: $('#detLabel').val(),
        purpose: $('#detPurpose').val(),
        owner: $('#detOwner').val(),
        device_type: $('#detType').val(),
    }, function () {
        $j.Ui.JBModal.close('detailModal');
        dtInventory.ajax.reload(null, false);
    });
}

function deleteRow(num) {
    $j.Common.Util.swalert('이 장비를 삭제하시겠습니까?', function () {
        $.post('/adm/ajax/dev/pc-inventory/delete', { num }, function () {
            dtInventory.ajax.reload(null, false);
        });
    }, ['삭제', '취소']);
}

let aceEditor = null;
let aceLoaded = false;

function loadAce(cb) {
    if (aceLoaded) return cb();
    const s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.32.7/ace.js';
    s.onload = function () { aceLoaded = true; cb(); };
    document.head.appendChild(s);
}

function openScriptEditor() {
    $.post('/adm/ajax/dev/pc-inventory/get-script', function (res) {
        const data = res.data || {};
        const html = `
            <div class="form-group">
                <label>파일명</label>
                <input type="text" id="scriptTag" class="form-control input-sm" value="${data.tag || 'pc_report.py'}" placeholder="pc_report.py">
            </div>
            <div id="aceEditor"></div>
            <div class="pci-ace-bar">
                <small class="text-muted" id="aceStatus"></small>
                <div>
                    <button class="btn btn-default btn-sm" data-pci="close" data-modal="scriptModal">취소</button>
                    <button class="btn btn-primary btn-sm" data-pci="saveScript">저장</button>
                </div>
            </div>
        `;
        $j.Ui.JBModal.html('scriptModal', html, '수집 스크립트 편집', {width: '900px'});

        loadAce(function () {
            aceEditor = ace.edit('aceEditor', {
                mode: 'ace/mode/python',
                theme: 'ace/theme/monokai',
                fontSize: 13,
                showPrintMargin: false,
                tabSize: 4,
                useSoftTabs: true,
                wrap: false,
            });
            aceEditor.setValue(data.body || '', -1);
            aceEditor.focus();

            aceEditor.session.on('change', function () {
                const lines = aceEditor.session.getLength();
                const chars = aceEditor.getValue().length;
                $('#aceStatus').text(lines + ' lines, ' + chars + ' chars');
            });
            aceEditor.session._emit('change');
        });
    });
}

function saveScript() {
    if (!aceEditor) return;
    $.post('/adm/ajax/dev/pc-inventory/save-script', {
        tag: $('#scriptTag').val(),
        body: aceEditor.getValue(),
    }, function () {
        $j.Ui.JBModal.close('scriptModal');
        aceEditor = null;
        alert('저장되었습니다.');
    });
}
